// src/components/TanProfiles.js
import React, { useState, useEffect } from 'react';
import { Container, ListGroup, Spinner, Alert, Badge, Button, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useGetTanProfilesQuery, useGetComponentsQuery } from '../../redux/services/tanProfilesApi';
import { useGetTanHistoryQuery } from '../../redux/services/historyApi';
import { useDispatch, useSelector } from 'react-redux';
import "./history.css"
const TanProfiles = () => {
  const profileData = useSelector((state) => state?.tanProfile?.profiles);
  const componentData = useSelector((state) => state?.tanProfile?.components);
  const history = useSelector((state) => state?.history?.data);

  const [currentPage, setCurrentPage] = useState(1);
  const { error: historyError, isLoading: historyLoading } = useGetTanHistoryQuery({
    page: {
      number: currentPage,
      limit: 1,
      status: 4
    }
  }, { skip: history });
  const { error: profileError, isLoading: profileLoading } = useGetTanProfilesQuery({ page: 1, limit: 999 });
  const { error: componentError, isLoading: componentLoading } = useGetComponentsQuery();


  useEffect(() => {
    if (history) {
      //   console.log("here")
      //  console.log(history);
    }
  }, [history]);

  const handleNextPage = () => {
    if (history?.current_page < history?.total_pages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (history?.current_page > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const buildItemBox = (user) => {
    let string = ""
    let userComps = user.session_component
    for (let i in userComps) {
      let component = userComps[i]
      let compType = Object.values(componentData).find((item) => item.id === parseInt(component.component_id))
      let fullComp = compType.component_values.find((comp) => comp.id === component.component_value_id)
      let newString = compType?.name === "Base Tan Level" ? "Spray Shade: " : compType?.name
      switch (compType.component_type) {
        case "integer":
          newString += " " + fullComp.value + " " 
          break
        case "string":
          const result = newString.endsWith("s") ? newString.slice(0, -1) : newString;
          newString = fullComp.value + " " + result + " "
          break
      }
      if (parseInt(i) + 1 < userComps.length) {
        newString += "+ "
      }
      string += newString
    }
    return (<div className='session-instance'>
      <div className='history-text'>
        {new Date(user.created_at).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}
      </div>
      <div className='session-items'>
        {string}
      </div>
    </div>)
  }

  return (
    <div className='history-div'>
      <h1>Session History</h1>
      <div className="history-nav">
        <span
          variant="secondary"
          onClick={handlePreviousPage}
          disabled={history?.current_page <= 1}
        >
          Previous page
        </span>
        <span>
          Page {history?.current_page} of {history?.total_pages}
        </span>
        <span
          variant="secondary"
          onClick={handleNextPage}
          disabled={history?.current_page >= history?.total_pages}
        >
          Next page
        </span>
      </div>
      {historyError ? <Container>{historyError.data.msg}</Container> : <div className='history-list'>
        {history?.users?.map((user) => (
          user.session_component.length ? buildItemBox(user) : null
        ))}
      </div>}

    </div>
  );
};

export default TanProfiles;
